/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyCredit from './pharmacy-credit';
import PharmacyCreditDetail from './pharmacy-credit-detail';
import PharmacyCreditUpdate from './pharmacy-credit-update';
import PharmacyCreditDeleteDialog from './pharmacy-credit-delete-dialog';

const PharmacyCreditRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyCredit />} />
    <Route path="new" element={<PharmacyCreditUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyCreditDetail />} />
      <Route path="edit" element={<PharmacyCreditUpdate />} />
      <Route path="delete" element={<PharmacyCreditDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyCreditRoutes;
